import React, { useState } from 'react';
import { Box, TextField } from '@mui/material';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const EditableDateCell = ({ id, field, value, label, saveEditedField, darkMode, equipment, categoryUuid, workId }) => {
    // Определяем цвета в зависимости от поля
    const getFieldColors = (field) => {
        switch (field) {
            case 'plan_start':
            case 'fact_start':
            case 'plan_end':
            case 'fact_end':
                return {
                    color: darkMode ? '#64b5f6' : '#1976d2',
                };
            case 'closing':
                return {
                    color: darkMode ? '#ff8f00' : '#e65100',
                };
            case 'cost':
                return {
                    color: darkMode ? '#e91e63' : '#c2185b',
                };
            case 'comment':
                return {
                    color: darkMode ? '#4caf50' : '#2e7d32',
                };
            default:
                return {
                    color: darkMode ? '#1976d2' : '#1976d2',
                };
        }
    };

    const fieldColors = getFieldColors(field);
    const [localValue, setLocalValue] = useState(value)

    // Преобразуем строку даты в объект Date для DatePicker
    const getDateFromString = (dateString) => {
        if (!dateString) return null;
        try {
            // Если дата в формате "YYYY-MM-DD" (из базы данных)
            if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
                return new Date(dateString);
            }

            // Если дата в формате "HH:MM DD-MM-YYYY"
            const dateTimeMatch = dateString.match(/^(\d{2}):(\d{2})\s(\d{2})-(\d{2})-(\d{4})$/);
            if (dateTimeMatch) {
                const [, hours, minutes, day, month, year] = dateTimeMatch;
                return new Date(`${year}-${month}-${day}`);
            }

            // Если дата в формате "DD-MM-YYYY"  
            const dateMatch = dateString.match(/^(\d{2})-(\d{2})-(\d{4})$/);
            if (dateMatch) {
                const [, day, month, year] = dateMatch;
                return new Date(`${year}-${month}-${day}`);
            }

            // Попытка парсинга как обычной даты
            const date = new Date(dateString);
            return isNaN(date.getTime()) ? null : date;
        } catch {
            return null;
        }
    };

    const handleDateChange = (date) => {
        if (date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;
            setLocalValue(formattedDate);
        } else {
            setLocalValue('');
        }
    };

    const handleBlur = () => {
        saveEditedField({
            rowId: id,
            field: field,
            value: localValue,
            isValueChanged: value !== localValue,
            shouldExitEditMode: false,
            equipment: equipment,
            categoryUuid: categoryUuid,
            workId: workId,
        });
    };

    return (
        <Box data-editing-cell="true" sx={{ position: 'relative' }}>
            {(() => {
                try {
                    return (
                        <DatePicker
                            selected={getDateFromString(localValue)}
                            onChange={handleDateChange}
                            onBlur={handleBlur}
                            onCalendarClose={handleBlur}
                            locale="ru"
                            dateFormat="dd.MM.yyyy"
                            autoFocus
                            showYearDropdown
                            showMonthDropdown
                            dropdownMode="select"
                            yearDropdownItemNumber={10}
                            scrollableYearDropdown
                            autoComplete="off"
                            customInput={
                                <TextField
                                    size="small"
                                    sx={{
                                        '& .MuiOutlinedInput-input': {
                                            p: '5px',
                                            cursor: 'pointer',
                                            color: darkMode ? '#ffffff' : '#333',
                                            fontSize: '0.875rem',
                                        },
                                        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderColor: fieldColors.color,
                                            borderWidth: '2px',
                                        },
                                        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                                            borderColor: darkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)',
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: darkMode ? '#bbb' : 'rgba(0,0,0,0.6)',
                                            fontSize: '0.875rem',
                                            '&.Mui-focused': {
                                                color: fieldColors.color,
                                            }
                                        },
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)',
                                            borderRadius: '4px',
                                        },
                                        bgcolor: darkMode ? '#2b2b2b' : '#fff',
                                        '& .MuiInputBase-root': {
                                            fontWeight: 500,
                                            fontSize: '0.8rem',
                                            borderRadius: '4px',
                                            width: '90px'
                                        },
                                        '& .MuiInputBase-input': {
                                            borderRadius: '4px',
                                        },
                                    }}
                                />
                            }
                            calendarClassName={darkMode ? 'dark-datepicker' : 'light-datepicker'}
                        />
                    );
                } catch (error) {
                    console.error('DatePicker error:', error);
                    return null;
                }
            })()}
        </Box>
    );
}

export default EditableDateCell;

